/**
 * Mascarade Noire — configuration centralisée "Halloween Premium"
 * Modifie les valeurs ci-dessous pour ajuster dates, seuils et interrupteurs d'effets.
 *
 * Important : les dates et seuils doivent rester conformes à tes politiques
 * (expédition : délais indicatifs de 7 à 15 jours ouvrés, commande conseillée
 * avant le 15 octobre ; livraison Standard offerte en France dès 65 €).
 */
window.MascaradeConfig = {
  halloweenDate: '2026-10-31T23:59:59+01:00',

  // Date de commande conseillée pour une livraison estimée avant Halloween
  // (reprise de la politique d'expédition).
  orderDeadline: '2026-10-15T23:59:59+02:00',

  // Conservés pour compatibilité (anciens scripts).
  targetDeliveryDate: '2026-10-30T18:00:00+01:00',
  deliveryDaysMin: 7,
  deliveryDaysMax: 15,

  // Livraison Standard offerte en France à partir de ce montant (en euros).
  freeShippingThreshold: 65,

  ghostHuntCode: 'FANTOME10',

  effects: {
    fog: true,
    customCursor: true,
    batTrail: true,
    embers: true,
    countdown: true,
    scrollReveal: true,
    candleProgress: true,
    magicCart: true,
    sound: false,
    easterEggs: true,
  },

  offrandes: {
    orderDeadlineSafetyDays: 3,
    processingDays: 1,
  },

  // Vidéo d'ambiance de l'accueil (fichiers hébergés dans Shopify > Contenu > Fichiers).
  // Laisser vide ('') pour la désactiver.
  heroVideo: {
    desktop: 'https://cdn.shopify.com/videos/c/vp/6141bf9b94ba4151aaca62a9413969cf/6141bf9b94ba4151aaca62a9413969cf.HD-720p-4.5Mbps-96328696.mp4',
    mobile: 'https://cdn.shopify.com/videos/c/vp/6141bf9b94ba4151aaca62a9413969cf/6141bf9b94ba4151aaca62a9413969cf.SD-480p-1.5Mbps-96328696.mp4',
  },

  // Vidéo d'ambiance derrière l'en-tête des pages collection.
  collectionVideo: {
    desktop: 'https://cdn.shopify.com/videos/c/vp/ed4159c697b44dbc88dcf807f68cab74/ed4159c697b44dbc88dcf807f68cab74.HD-720p-4.5Mbps-96589353.mp4',
    mobile: 'https://cdn.shopify.com/videos/c/vp/ed4159c697b44dbc88dcf807f68cab74/ed4159c697b44dbc88dcf807f68cab74.SD-480p-1.5Mbps-96589353.mp4',
  },

  // Vidéos propres à certaines collections (clé = handle de la collection).
  // Les autres collections gardent la vidéo commune ci-dessus.
  collectionVideos: {
    'decoration-gothique': {
      desktop: 'https://cdn.shopify.com/videos/c/vp/b70bd829688943d6b00773a95f68af9f/b70bd829688943d6b00773a95f68af9f.HD-720p-4.5Mbps-96674083.mp4',
      mobile: 'https://cdn.shopify.com/videos/c/vp/b70bd829688943d6b00773a95f68af9f/b70bd829688943d6b00773a95f68af9f.SD-480p-1.5Mbps-96674083.mp4',
    },
    'offre-3-pour-2': {
      desktop: 'https://cdn.shopify.com/videos/c/vp/b70bd829688943d6b00773a95f68af9f/b70bd829688943d6b00773a95f68af9f.HD-720p-4.5Mbps-96674083.mp4',
      mobile: 'https://cdn.shopify.com/videos/c/vp/b70bd829688943d6b00773a95f68af9f/b70bd829688943d6b00773a95f68af9f.SD-480p-1.5Mbps-96674083.mp4',
    },
    'accessoires-gothiques': {
      desktop: 'https://cdn.shopify.com/videos/c/vp/45ec86b7b07140ee82fde2564bac31ea/45ec86b7b07140ee82fde2564bac31ea.HD-720p-4.5Mbps-96837247.mp4',
      mobile: 'https://cdn.shopify.com/videos/c/vp/45ec86b7b07140ee82fde2564bac31ea/45ec86b7b07140ee82fde2564bac31ea.SD-480p-1.5Mbps-96837247.mp4',
    },
  },
};

(function () {
  try {
    var cfg = window.MascaradeConfig;
    var now = new Date();
    var halloween = new Date(cfg.halloweenDate);
    if (now > halloween) {
      document.documentElement.classList.add('mn-off-season');
    }
  } catch (e) {
    /* silencieux : ne doit jamais casser le reste du site */
  }
})();
